module.exports = __webpack_public_path__ + "static/build-pipeline-55231c61390da96de33acb4c82828bbf.svg";